// External Imports
import React from "react";
import parse from "html-react-parser";
import clsx from "clsx";
import dynamic from "next/dynamic";

// Internal Imports
import { getDefaultACFSettings } from "@/helpers/getDefaultACFSettings";

// Type Imports
import type { ITextEditor } from "@/types/ACFLayouts/TextEditor";

// Lazy Load Imports
const ButtonGroup = dynamic(() =>
  import("../buttons/ButtonGroup").then((mod) => mod.ButtonGroup),
);

type Props = {
  data: ITextEditor;
  parentWidth?: number;
  nested?: boolean;
};

export const TextEditor = ({ data, nested = false }: Props) => {
  // Default ACF Settings
  const { hide, paddings, margins, classes, id, backgroundColor, bgImgStyles } =
    getDefaultACFSettings(data);

  // Group all main layout classes here
  const combinedClasses = clsx(
    "relative",
    "acf-layout",
    "text-editor-block",
    paddings,
    margins,
    classes,
  );

  if (hide || !data.content) {
    return <></>;
  }

  return (
    <section
      id={id}
      className={`${combinedClasses}`}
      style={{ ...bgImgStyles, backgroundColor }}
    >
      <div
        className={`content content-flow ${data.text_align} ${!nested ? data.wrapper_width : ""}`}
      >
        {parse(data.content)}

        {data?.links && <ButtonGroup links={data.links} />}
      </div>
    </section>
  );
};
